import { Button } from "src/base-components/Button";

export const DashboardEditActions: React.FC<{
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}> = ({ onSave, onCancel, isSaving = false }) => (
  <div className="flex h-12 items-center gap-x-2 px-3">
    <Button
      dataLoc="dashboard-edit-cancel"
      disabled={isSaving}
      size="sm"
      variant="secondary"
      onClick={onCancel}
    >
      Cancel
    </Button>
    <Button
      dataLoc="dashboard-edit-save"
      loading={isSaving}
      size="sm"
      variant="primary"
      onClick={onSave}
    >
      Save
    </Button>
  </div>
);
